import React from 'react'
import R from 'ramda'
import { cn, makePostText } from '../components/helpers';
import posts from '../components/fixtures/posts';
import video from '../../videos/cartier.mp4'
// import cartier from './videos'

/**
 * Post
 */

class Post extends React.Component {
	constructor(props) {
		super(props)
		this.registerRef = this.registerRef.bind(this)
		this.postLoaded = this.postLoaded.bind(this)
	}

	shouldComponentUpdate(nextProps, nextState) {
		return false
	}

	componentDidMount() {
		if (this.element.tagName.toLowerCase() === 'img') {
			if (this.element.complete) this.postLoaded()
		} else {
			this.postLoaded()
		}
	}

	registerRef(element) {
		this.element = element
	}

	postLoaded() {
		this.props.addToLoadedCount(this.props.index)
	}

	render() {

		const classNames = ['cartier__post']
		classNames.push(`cartier__post--${this.props.type}`)
		if (this.props.type === 'image') {
			return (
				<div className={cn(classNames)}>
					<img
						ref={this.registerRef}
						onLoad={this.postLoaded}
						onError={this.postLoaded}
						alt="littlebabyangel"
						src={`https://luckyme-public.s3.amazonaws.com/littlebabyangel/cartier-tumblr/${this.props.filename}`}
					/>
				</div>
			)
		}
		if (this.props.type === 'text') {
			this.postLoaded()
			return (
				<div ref={this.registerRef} className={cn(classNames)} dangerouslySetInnerHTML={{ __html: makePostText(this.props.body) }} />
			)
		}
		return null
	}
}

Post.propTypes = {
	// title: PropTypes.string
}

Post.defaultProps = {
	// title: 'My Title'
}


/**
 * Cartier
 */

class Cartier extends React.Component {
	constructor(props) {
		super(props)
		this.debounceTimer = null

		this.state = {
			postsToShow: 15,
			complete: false,
		}
		this.addToLoadedCount = this.addToLoadedCount.bind(this)
		this.onVideoPlay = this.onVideoPlay.bind(this)
		this.playVideo = this.playVideo.bind(this)

		this.loaded = 0
		this.watchScroll = this.watchScroll.bind(this)
		this.calculate()
	}

	componentDidMount() {
		document.documentElement.scrollTop = 0
		window.addEventListener('scroll', this.watchScroll)
		this.calculate()
		this.loaded = 0
		this.playVideo()
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.watchScroll)
	}

	onVideoPlay() {
		this.setState({
			needsInteraction: false,
		})
		window.seeThru.create(this.video)
	}

	playVideo() {
		this.video.play().then(() => {
		}).catch((err) => {
			this.setState({
				needsInteraction: true,
			})
		})
	}

	calculate() {
		clearTimeout(this.debounceTimer)
		this.debounceTimer = setTimeout(() => {
			const body = { document }
			const html = document.documentElement
			this.windowHeight = window.innerHeight || html.clientHeight || body.clientHeight
			this.documentHeight = this.mainContainer.scrollHeight
		}, 250)
	}

	watchScroll() {
		if (!this.mainContainer) return
		const scrollTop = pageYOffset || document.body.scrollTop;
		if (scrollTop + this.windowHeight >= this.mainContainer.scrollHeight - (0.5 * this.windowHeight)) {
			const postsToShow = Math.min(this.state.postsToShow + 10, posts.length)
			const complete = (postsToShow === posts.length)
			this.setState({
				postsToShow,
				complete
			})
		}
		if (scrollTop >= this.mainContainer.scrollHeight) {
			this.props.history.push('/')
		}
	}

	addToLoadedCount() {
		this.loaded += 1
		if (this.loaded === posts.length) {
			this.setState({ complete: true })
		}
	}

	render() {
		const visiblePosts = R.take(this.state.postsToShow)(posts)
		const classNames = ['cartier']
		if (this.state.complete) classNames.push('cartier--complete')
		if (this.state.needsInteraction) classNames.push('needsInteraction')
		return (
			<section ref={(element) => { this.mainContainer = element }} className={cn(classNames)}>
				<button className="videoPlay" onClick={this.playVideo}><span /></button>
				<div className="videoFrame videoFrame--full videoFrame--alpha">
					<video
						className="video--full video--alpha"
						onPlay={this.onVideoPlay}
						ref={(element) => { this.video = element }}
						src={video}
					/>
				</div>
				<div className="cartier__blog">
					{visiblePosts.map((p, i) => <Post key={p.body || p.filename} index={i} {...p} addToLoadedCount={this.addToLoadedCount} />)}
				</div>
			</section>
		)
	}
}


export default Cartier




// WEBPACK FOOTER //
// ./src/pages/Cartier.js